<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col
          cols="12"
          md="8"
          lg="6"
          xl="6"
          class="text-center">
        <v-card class="elevation-12" max-width="400">
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-toolbar-title>
              {{ $t("Вход в систему") }}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-progress-linear
                :active="isLoading"
                color="loader"
                indeterminate />
            <general-error v-if="!!generalError" />
            <!-- focusOnBtn метод из глобального миксина -->
            <ValidationObserver
                ref="loginform"
                @keydown.native.enter="focusOnBtn('loginBtn')">
              <form>
                <validatable-text-input
                    v-model="account.login"
                    v-test="{ input: 'login' }"
                    rules="required"
                    :label="$t('Логин')"
                    prepend-icon="support_agent" />
                <validatable-text-input
                    v-model="account.password"
                    v-test="{ input: 'password' }"
                    rules="required"
                    :label="$t('Пароль')"
                    prepend-icon="lock"
                    type="password" />
                <validatable-recaptcha
                    v-if="captchaMethod === CAPTCHA_METHODS.GOOGLE"
                    ref="recaptcha"
                    v-model="account.captcha" />
                <validatable-captcha-gen
                    v-if="captchaMethod === CAPTCHA_METHODS.CAPTCHA_GEN"
                    ref="captchagen"
                    :captcha="account.captcha"
                    @input="inputCaptchaGen" />
              </form>
            </ValidationObserver>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
                id="loginBtn"
                ref="loginBtn"
                v-test="{ btn: 'login' }"
                color="primary"
                :disabled="isLoading"
                @click.stop="logInUser">
              {{ $t("Войти") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Вход в систему только для админов

  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import ValidatableRecaptcha from '@/components/reused/ui/ValidatableRecaptcha.vue'
  import ValidatableCaptchaGen from '@/components/reused/ui/ValidatableCaptchaGen.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { mapActions, mapState } from 'vuex'
  import { ACCOUNT, CAPTCHA } from '@/constants/store.js'
  import { CAPTCHA_METHODS } from '@/constants/business'

  export default {
    components: {
      ValidatableTextInput,
      GeneralError,
      ValidatableRecaptcha,
      ValidatableCaptchaGen
    },
    data () {
      return {
        CAPTCHA_METHODS,
        account: {
          login: '',
          password: '',
          captchaId: '',
          captcha: ''
        },
        isLoading: false
      }
    },
    computed: {
      ...mapState(CAPTCHA.NAMESPACE, {
        captchaMethod: state => (state[CAPTCHA.STATE.METHOD] || ''),
        captchaId: state => (state[CAPTCHA.STATE.CAPTCHA_ID] || '')
      })
    },
    created: function () {
      const vm = this
      vm.hideErrorAction()
        .then(vm.routingAuthorizedUser)
        .then(vm.getCaptchaMethod)
        .catch((error) => {
          vm.isLoading = false
          // eslint-disable-next-line no-console
          console.error(error)
        })
    },
    methods: {
      ...mapActions(ACCOUNT.NAMESPACE, {
        logInAdminAction: ACCOUNT.ACTIONS.LOG_IN_ADMIN,
        setUserNameAction: ACCOUNT.ACTIONS.SET_USER_NAME
      }),
      ...mapActions(CAPTCHA.NAMESPACE, {
        getCaptchaMethodAction: CAPTCHA.ACTIONS.GET_CAPTCHA_METHOD
      }),
      logInUser: async function () {
        try {
          const result = await this.$refs.loginform.validate()
          if (!result) {
            return
          }
          this.isLoading = true
          await this.logInAdminAction(this.account)
          await this.fillStoreAfterLogin(this.account.login)
          this.isLoading = false
        } catch (error) {
          if (this.$refs.recaptcha &&
            this.captchaMethod === CAPTCHA_METHODS.GOOGLE) {
            this.$refs.recaptcha.resetCaptcha()
          }
          this.account.password = ''
          this.account.captcha = ''
          this.throwIfUnknownError(error)
        } finally {
          this.isLoading = false
        }
      },
      fillStoreAfterLogin: async function (login) {
        this.isLoading = true
        try {
          await this.setUserNameAction(login)
          await this.routingAuthorizedUser()
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error)
        } finally {
          this.isLoading = false
        }
      },
      routingAuthorizedUser: async function () {
        if (!this.isLoggedIn) {
          return
        }
        if (this.isAdmin) {
          // если пользователь аутентифицирован, перенаправляем в соответствии с уровнем доступа
          this.goToRoute(`${this.urlRootPath}/manage`)
        } else {
          // если не админ, то выходим из системы и перенаправляем на общую страницу
          await this.exitAction()
          this.goToRoute(`${this.urlRootPath}/`)
        }
      },
      getCaptchaMethod: async function () {
        this.isLoading = true
        try {
          await this.getCaptchaMethodAction()
        } catch (error) {
          this.throwIfNotServerError(error)
        } finally {
          this.isLoading = false
        }
      },
      inputCaptchaGen: function (value) {
        this.account.captcha = value
        this.account.captchaId = this.captchaId
      }
    }
  }
</script>
